import React from "react";

const About = () => {
  return (
    <div className="bg-lightblue-5 flex flex-col items-center w-full md:py-10 py-5 h-full">
      <div className="h-full relative max-w-screen-xl flex-col-reverse md:flex-row flex items-start pt-5 gap-5 px-5 xl:px-0">
        <div className="w-full md:w-1/2 flex items-center justify-center h-full">
          <img
            src="/assets/images/about/banner.webp"
            alt="Clear Choice Cleaning Services team at work"
            width="857"
            height="1182"
            className="md:w-auto md:h-[780px] h-auto w-full object-contain"
          />
        </div>
        <div className="w-full md:w-1/2 h-full flex md:items-start items-center flex-col">
          <p className="text-7xl text-blue-9 md:mb-10 mb-5">About us</p>

          <div className="bg-blue-gradient px-5 py-5 md:py-[75px] rounded text-white gap-8 flex flex-col relative w-[95%]">
            <p className=" text-sm md:text-lg text-justify">
              At Clear Choice, we are committed to providing exceptional
              cleaning solutions tailored to meet the unique needs of each
              client. As a premier cleaning services company, we offer a
              comprehensive range of residential and commercial cleaning
              services designed to enhance the comfort and cleanliness of your
              space. Our team of professional cleaners is highly trained, fully
              insured, and dedicated to delivering meticulous attention to
              detail with every service we provide.
            </p>
            <p className="text-sm md:text-lg text-justify">
              Our mission is to exceed your expectations with every clean. We
              understand that a clean environment is crucial for your well-being
              and productivity, and we strive to create spaces that you can be
              proud of. Let us handle the cleaning, so you can focus on what
              matters most to you.
            </p>
            <p className="text-sm md:text-lg text-justify">
              Contact us today to schedule your cleaning service and experience
              the Clear Choice difference!
            </p>

            <img
              src="/assets/images/about/corner-up.png"
              alt=""
              className="w-[68px] absolute hidden xl:block -top-[44px] -right-[48px]"
            />
            <img
              src="/assets/images/about/corner-down.png"
              alt=""
              className="w-[68px] absolute hidden xl:block -bottom-[44px] -right-[48px]"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
